<script setup lang="ts">
  const route = useRoute()

  const mainElement = ref<HTMLElement | null>(null)
  const { arrivedState } = useScroll(mainElement)
  const { width } = useWindowSize()

  const navigationStore = useNavigationStore()
  const authStore = useAuthStore()
  const showNavigation = computed(() => authStore.isUserLoaded && navigationStore.hasVisibleItems)
</script>

<template>
  <div class="h-svh grid grid-rows-[auto_1fr]">
    <TheHeader
      :environment="route.meta.environment ?? 'portal'"
      :class="{ 'shadow-md': !arrivedState.top }"
      class="sticky top-0 z-[105] transition-shadow"
    />
    <div class="grid grid-cols-[auto_1fr] h-full">
      <TheNavigation v-if="showNavigation" :routes="navigationStore.items ?? []" />
      <main
        ref="mainElement"
        class="h-[calc(100vh-5rem)] max-h-full overflow-y-auto"
        :class="[width < 1280 && showNavigation ? '_ml-14' : '', $slots.utility ? 'mr-64' : '']"
      >
        <div class="p-4 md:p-8 lg:p-12 h-fit w-full">
          <slot />
        </div>
        <div
          v-if="$slots.utility"
          class="bg-[#F5F5F5] border-l fixed right-0 bottom-0 top-20 overflow-y-auto"
        >
          <div class="w-64 h-full flex flex-1 flex-col justify-between">
            <slot name="utility" />
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<style scoped></style>
